<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="info">
    <b-navbar-brand
      v-if="empresa.token !== ''"
      to="/">
      <button
        v-if="ruta_actual !== '/'"
        class="d-block d-sm-none btn btn-outline-light btn-sm">
        Inicio
      </button>
      <img
        alt="Panel de control Empresas de Mudanzas"
        :src="base_url + 'img/pro/favicon_mm_pro.webp'"
        class="d-none d-sm-block img-fluid"
        style="max-height: 38px" />
    </b-navbar-brand>
    <b-navbar-brand v-else>
      <button
        v-if="ruta_actual !== '/login'"
        class="d-block d-sm-none btn btn-outline-light btn-sm">
        Inicio
      </button>
      <img
        alt="Panel de control Empresas de Mudanzas"
        :src="base_url + 'img/pro/logo_pro_white.png'"
        class="d-none d-sm-block img-fluid"
        style="max-height: 43px" />
    </b-navbar-brand>

    <b-navbar-nav
      v-if="empresa.token !== '' && ruta_actual !== '/'"
      class="d-none d-sm-block">
      <router-link
        class="btn btn-outline-light mr-5"
        to="/">
        Inicio
      </router-link>
    </b-navbar-nav>

    <b-navbar-toggle
      v-if="empresa.token !== ''"
      target="nav-collapse-dashboard-mm-pro"></b-navbar-toggle>

    <b-collapse
      v-if="empresa.token !== ''"
      id="nav-collapse-dashboard-mm-pro"
      is-nav>
      <b-navbar-nav>
        <b-input-group class="mt-3 mt-lg-0">
          <b-form-input
            v-model.trim="a_buscar"
            name="buscar"
            placeholder="folio, cliente..."
            type="search"
            @keyup.enter="onSubmit"></b-form-input>
          <b-input-group-append>
            <b-button
              :disabled="a_buscar == '' ? true : false"
              variant="outline-light"
              @click="onSubmit">
              <i class="fas fa-search"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto d-flex align-items-lg-center">
        <b-nav-item
          v-if="
            typeof empresa.membresia_paga == 'undefined' || empresa.membresia_paga <= 0
          "
          :href="base_url + 'membresia/' + empresa.clave"
          class="mr-4">
          <button class="btn btn-warning btn-sm text-white font-weight-bold">
            Comprar membresía
          </button>
        </b-nav-item>
        <b-nav-item
          v-b-tooltip.hover
          class="mr-4"
          active
          title="Centro de ayuda. Tutoriales, consejos y tips para ganar más"
          :href="base_url + 'centro-ayuda-empresas-mudanzas'">
          <i class="far fa-question-circle"></i>
        </b-nav-item>

        <notificaciones-proveedor class="mr-4"></notificaciones-proveedor>

        <b-nav-item
          v-b-tooltip.hover
          active
          class="mr-4"
          title="Agendar llamadas con clientes para aumentar mis ventas"
          to="/calendario_llamada">
          <i class="far fa-calendar-alt"></i>
        </b-nav-item>
        <b-nav-item-dropdown right>
          <template #button-content>
            <i class="far fa-user"></i>
            {{ empresa.usuario }}
          </template>
          <b-dropdown-item to="/perfil">Perfil</b-dropdown-item>
          <b-dropdown-item
            :to="`/cambiar_contrasena?token=${empresa.token}&id=${empresa.id}&modulo=pro`">
            Cambiar contraseña
          </b-dropdown-item>
          <b-dropdown-item to="/configurar_alertas_trabajo">
            Configurar alertas de trabajo
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :href="base_url + 'pro/contenido'">
            Contenido y publicaciones
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/papelera">
            Ver solicitudes que has archivado
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :href="base_url + 'privacidad'">
            Aviso de privacidad
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="cerrar_sesion">Salir</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { borrar_sesion_local_storage } from 'views/components/mm_pro/components/sesion.js';
import { mapFields, createHelpers } from 'vuex-map-fields';
import {
  remover_fcm,
  remover_token_fcm,
} from 'views/components/mm_pro/components/notificaciones/fcm.js';
import { empty } from 'views/components/php.js';

const { mapFields: mapFieldsBuscador } = createHelpers({
  getterType: 'store_buscador/getFieldBuscador',
  mutationType: 'store_buscador/updateFieldBuscador',
});

export default {
  components: {
    notificacionesProveedor: () =>
      import('views/components/mm_pro/components/notificaciones/notificaciones.vue'),
  },
  computed: {
    ...mapFieldsBuscador(['busqueda', 'iniciar_busqueda']),
    ...mapFields(['empresa']),
  },
  watch: {
    $route(to, from) {
      this.ruta_actual = to.path;
    },
  },
  data() {
    return {
      a_buscar: '',
      ruta_actual: '/',
    };
  },
  methods: {
    onSubmit(evt) {
      if (empty(this.a_buscar)) {
        evt.preventDefault();
        return;
      }
      this.busqueda = this.a_buscar;
      this.a_buscar = '';

      this.iniciar_busqueda = true;

      if (this.$router.currentRoute.path != '/buscador') {
        this.$router.push({ name: 'buscador' });
      }
    },
    async cerrar_sesion() {
      if (is_app) {
        await remover_fcm();
        await remover_token_fcm();
        localStorage.removeItem('usuario');
        localStorage.removeItem('ultima_actualizacion_token_fcm');
        this.empresa.id = 0;
        this.empresa.token = '';
        this.$router.replace('/login');
      } else {
        borrar_sesion_local_storage();
      }
    },
  },
};
</script>
